import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import home from '@/components/home'
import service from '@/components/service'
import aboutUs from '@/components/aboutUs'
import cooperation from '@/components/cooperation'

Vue.use(Router)
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
export default new Router({
//   mode: 'history',  //去掉url中的#
  routes: [
    {path:'',redirect:"home"},
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
        path: '/service',
        name: 'service',
        component: service
      },
      {
        path: '/cooperation',
        name: 'cooperation',
        component: cooperation
      },
      {
        path: '/aboutUs',
        name: 'aboutUs',
        component: aboutUs
      },
       
   
   
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js